import NoDeals from '../NoDeals';

import PopularDestinations from './PopularDestinations';

import type { PopularDestinationsProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/PopularDestinationsProps';

const PopularDestinationsWrapper = (props: PopularDestinationsProps) => {
  if (!props.popularDestinations || props.popularDestinations.length === 0) {
    if (!props.noDeals) {
      return null;
    }
    return <NoDeals {...props.noDeals} />;
  }
  return <PopularDestinations {...props} />;
};

export default PopularDestinationsWrapper;
